/**
 * Константы для управления темой
 * # ⛓️ CURSOR_ANCHOR:ui:theme-constants
 */

(function() {
  'use strict';

  window.THEME_CONSTANTS = {
    STORAGE_KEY: 'slovary-theme',
    PROFILE_STORAGE_KEY: 'slovary-color-profile',
    LIGHT: 'light',
    DARK: 'dark',
    AUTO: 'auto',
    PROFILES: {
      DEFAULT: 'default',
      RO_BLUE: 'ro_blue',
      CITRUS: 'citrus',
      BARBIX: 'barbix',
      NOCTURNAL: 'nocturnal',
      EMBERGLO: 'emberglo',
      BLUEBERRY: 'blueberry'
    }
  };
})();

